import AuthService from "./AuthServices"

const IDLE_TIMEOUT_MS = 60 * 60 * 1000 // 1 hour

const ACTIVITY_EVENTS: string[] = [
  "mousemove",
  "keydown",
  "click",
  "scroll",
  "touchstart"
]

let idleTimer: ReturnType<typeof setTimeout> | null = null

const resetTimer = (): void => {
  if (idleTimer) {
    clearTimeout(idleTimer)
  }
  idleTimer = setTimeout(() => {
    console.log("User idle for 1 hour – logging out")
    AuthService.doLogout()
  }, IDLE_TIMEOUT_MS)
}

const startIdleTimeout = (): void => {
  ACTIVITY_EVENTS.forEach((event) => {
    document.addEventListener(event, resetTimer, { passive: true })
  })
  resetTimer()
}

const stopIdleTimeout = (): void => {
  ACTIVITY_EVENTS.forEach((event) => {
    document.removeEventListener(event, resetTimer)
  })
  if (idleTimer) {
    clearTimeout(idleTimer)
    idleTimer = null
  }
}

export { startIdleTimeout, stopIdleTimeout }
